module.exports = __webpack_public_path__ + "static/media/main15.a4728e52.png";